import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { closeModal } from '../actions/modal';
import { notificationActions } from '../components/Notification/redux/actions';
import { SelectField } from '../containers/Form';
import Wizard from '../containers/Modal/Wizard';
import { actions as capsActions } from '../pages/ShipperCapsDetails/redux/actions';
import { UPDATE_DEVICE_SAMPLE_RESULT } from '../pages/ShipperCapsDetails/redux/constants';
import Strings from '../Strings';

export const EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME = 'edit-device-sample-status-modal';

const getErrorMessage = response => {
  if (response?.type === UPDATE_DEVICE_SAMPLE_RESULT) {
    return null;
  }
  if (response?.response?.data?.standard_error?.message) {
    return response.response.data.standard_error.message;
  }
  if (response?.response?.data?.error?.message || response?.error) {
    return response.response?.data?.error?.message || response.error;
  }
  return Strings.errors.unknownError;
};

function EditDeviceSampleStatusModal(props) {
  const { data, onCancel, updateDeviceSample, refreshDeviceDetails, showNotification } = props;
  const [isSample, setIsSample] = React.useState(!!data?.isSample);
  const [isSaving, setIsSaving] = React.useState(false);

  React.useEffect(() => {
    setIsSample(!!data?.isSample);
  }, [data?.isSample]);

  const onSubmit = () => {
    if (!data?.deviceId || isSaving) {
      return;
    }

    setIsSaving(true);
    updateDeviceSample(data.deviceId, isSample).then(response => {
      const errorMessage = getErrorMessage(response);
      if (errorMessage) {
        showNotification(errorMessage, 5000, true);
        setIsSaving(false);
        return;
      }

      showNotification(Strings.deviceInvoices.sampleStatusUpdated);
      if (data?.onSuccess) {
        data.onSuccess();
      } else if (data?.selectedDevice && data?.capDetailsRequest) {
        refreshDeviceDetails(data.selectedDevice, data.capDetailsRequest);
      }
      onCancel();
    });
  };

  const pages = [
    {
      id: 'edit-device-sample-status',
      title: Strings.deviceInvoices.editSampleStatus,
      content: (
        <>
          <SelectField
            id="device-sample-status"
            name="device-sample-status"
            label={Strings.status}
            value={isSample ? 'sample' : 'regular'}
            onChange={option => setIsSample(option.value === 'sample')}
            data={[
              { value: 'regular', label: Strings.deviceInvoices.regular },
              { value: 'sample', label: Strings.deviceInvoices.sample },
            ]}
            isRequired
          />
          <div className="caution">
            {Strings.deviceInvoices.sampleStatusChangeWarning}
          </div>
        </>
      ),
      nextButton: { text: Strings.save },
      canGoNext: !isSaving && isSample !== !!data?.isSample,
    },
  ];

  return (
    <Wizard
      name={EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME}
      pages={pages}
      onSubmit={onSubmit}
    />
  );
}

EditDeviceSampleStatusModal.propTypes = {
  data: PropTypes.shape({
    capDetailsRequest: PropTypes.shape(),
    deviceId: PropTypes.string.isRequired,
    isSample: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func,
    selectedDevice: PropTypes.string,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  refreshDeviceDetails: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  updateDeviceSample: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  data: state.modals[EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME]
    && state.modals[EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME].data,
});

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(closeModal(EDIT_DEVICE_SAMPLE_STATUS_MODAL_NAME)),
  refreshDeviceDetails: (id, pageRequest) => dispatch(capsActions.getCapsDetails(id, pageRequest)),
  showNotification: (message, timeout, error) => dispatch(notificationActions.show(message, timeout, error)),
  updateDeviceSample: (deviceId, isSample) => dispatch(capsActions.updateDeviceSample(deviceId, isSample)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDeviceSampleStatusModal);
